import React from 'react';
import { useSelector } from 'react-redux';

const MobileTitle = () => {
  const { coordinates } = useSelector((state) => state.properties);
  const { desktopDevice } = useSelector((state) => state.viewportSlice);

  if (desktopDevice) return null;

  return (
    <div className='typo-subtitle vesta-indigo-100'>
      <div>Bien{coordinates.length > 1 && 's'}</div>
      <div className='typo-h3 vesta-indigo-100'>{coordinates.length}</div>
    </div>
  )
};

export default MobileTitle;
